import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CCard, CCol, CRow } from '@coreui/react';
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Firebase v9
import newsIcon from '../../../assets/icons/social-icon.png';

import Friends from '../Friends';
import Social from '../Social/Social';
import Suggestions from '../Social/Suggestions';
import Snapshot from '../Snapshot';
import './SocialDashboard.scss';
import NewsFeed from './NewsFeed'; // Import the NewsFeed component
import VideoFeed from './VideoFeed'; // Import the VideoFeed component
import Horoscope from '../Horoscope/Horoscope'; // Import the Horoscope component
// Importing icons
import friendsIcon from '../../../assets/icons/friends-icon.png';
import socialIcon from '../../../assets/icons/social-icon.png';
import suggestionsIcon from '../../../assets/icons/suggestions-icon.png';
import snapshotIcon from '../../../assets/icons/snapshot-icon.png';
import { useGeolocation } from '../Social/useGeolocation'; // Create this custom hook
//import { useWeather } from '../Social/useWeather'; // Create this custom hook
import { useActivity } from '../Social/useActivity'; // Create this custom hook
import WeatherWidget from '../../widgets/WeatherWidget'; // Import the WeatherWidget component
import SocialDashboardResponsive from './SocialDashboardResponsive';

// It automatically detects and loads the right version!
// Initialize Firebase


const SocialDashboard = () => {
    const [googleAccessToken, setGoogleAccessToken] = useState(localStorage.getItem('googleAccessToken') || '');
    const { coordinates } = useGeolocation();
   // const { weather } = useWeather(coordinates);
    const { activities } = useActivity();




    return (
        <div className="social-dashboard">
            <h1 className="dashboard-title">Social Overview</h1>

            <CRow>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <img src={newsIcon} alt="News" className="card-icon" />
                            <h2>News</h2>
                        </div>
                        <NewsFeed />
                    </CCard>
                </CCol>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <img src={suggestionsIcon} alt="Suggestions" className="card-icon" />
                            <h2>Local Attractions</h2>
                        </div>
                        <Suggestions coordinates={coordinates} />
                    </CCard>
                </CCol>
            </CRow>

            {/* Hidden Components - Friends and Activity Tracker */}
            {/* 
            <CRow>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <img src={socialIcon} alt="Social" className="card-icon" />
                            <h2>Activity Tracker</h2>
                        </div>
                        <Social activities={activities} />
                    </CCard>
                </CCol>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <img src={friendsIcon} alt="Friends" className="card-icon" />
                            <h2>Friends</h2>
                        </div>
                        <Friends googleAccessToken={googleAccessToken} />
                    </CCard>
                </CCol>
            </CRow>
            */}

            <CRow>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <img src={socialIcon} alt="Video Feed" className="card-icon" />
                            <h2>Video Feed</h2>
                        </div>
                        <VideoFeed />
                    </CCard>
                </CCol>
                <CCol xs="12" sm="6">
                    <CCard className="dashboard-card">
                        <div className="card-header">
                            <span className="card-icon">🔮</span>
                            <h2>Daily Horoscope</h2>
                        </div>
                        <Horoscope />
                    </CCard>
                </CCol>
            </CRow>

            <CRow>
                <CCol xs="12" sm="6">
                    {/* Weather Widget */}
                    <WeatherWidget />
                </CCol>
            </CRow>
        </div>
    );
};

export default SocialDashboard;
